import type { SxProps, TypographyProps } from "@mui/material";
import { Typography } from "@mui/material";
import type React from "react";

export interface SectionHeaderProps {
  children: React.ReactNode;
  sx?: SxProps;
  color?: TypographyProps["color"];
}

export const SectionHeader = ({ children, sx, color = "text.primary" }: SectionHeaderProps) => (
  <Typography variant="h6" fontWeight={600} mb={2} color={color} sx={sx}>
    {children}
  </Typography>
);
